module.exports = __webpack_public_path__ + "static/media/shia-1.27e0f221.mp3";